export default {
  setRestaurante(state, r) {
    state.restaurante = r;
  },
  setRestauranteObj(state, obj) {
    state.restauranteObj = obj;
  },
  setProductos(state, p) {
    state.productos = p;
  },
  setCategorias(state, c) {
    state.categorias = c;
  },
  setDescuentos(state, d) {
    state.descuentos = d;
  },
}